export enum DamageConditionType {
  Disassembly = 'DISASSEMBLY',
  Repair = 'REPAIR',
}

export const DAMAGE_CONDITION_TEXTS = {
  [DamageConditionType.Disassembly]: 'Demontering',
  [DamageConditionType.Repair]: 'Reparation',
};
